import { ensureNonNullable } from "@neonaut/lib-js/nonNullable";
export default function fromPixel([x, y], resolution) {
    return [
        ensureNonNullable(x) * resolution,
        ensureNonNullable(y) * -1 * resolution,
    ];
}
